// Appended by APIDeck Vault on returning from a completed authorization.
export const AUTHORIZED_CONNECTION_PARAM_NAME = "authorizedConnection"
